module.exports = __webpack_public_path__ + "media/images/recruit/environments/ph_05-ff9c5dc5506ce84e43db8ccab3dffb17.jpg";